import {
  LandingSection,
  LandingSectionContainer,
  LandingSectionTitle
} from '#/src/custom/components/Landing/LandingSection'
import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  ListItem,
  Text,
  UnorderedList,
  VStack
} from '@chakra-ui/react'

const infoItems = [
  {
    title: 'What are the benefits of the fixed price offer?',
    content: {
      text: `
        A fixed-price model is perfect for your business if you’re working with tight margins.
        You’ll benefit from predictable costs, simpler onboarding and processes, stronger 
        relationships with us at Granditude, and more consistency—especially if you’re a smaller or growing retailer.
      `,
      list: {
        title: 'This model is great for you if:',
        items: [
          'You run an SME with steady and predictable sales volumes.',
          'You need to prioritize budgeting and cost certainty.',
          'You’re looking to simplify and streamline cost complexities in your operations.'
        ]
      }
    }
  },
  {
    title: 'Why should I choose the variable offer model?',
    content: {
      text: `
       Variable pricing is a great fit for your business if you’re looking to align costs with actual usage. 
       This model scales with your success, helping you maximize revenue as your business grows.
      `,
      list: {
        title: 'This model is ideal for you if:',
        items: [
          'Your retail operations experience significant variability in transaction volumes.',
          'Your business sees large seasonal demand spikes and needs flexibility to match.'
        ]
      }
    }
  }
]

export const SectionMoreInfo = () => {
  return (
    <LandingSection gap={32}>
      <LandingSectionContainer gap={10}>
        <LandingSectionTitle fontSize="2xl" textAlign="left">
          Need more info?
        </LandingSectionTitle>

        <Accordion allowMultiple as={VStack} gap={10} w="100%" alignItems="stretch">
          {infoItems.map((item) => (
            <AccordionItem
              key={item.title}
              color="text.light"
              borderTopWidth={0}
              _last={{ borderBottomWidth: 0 }}>
              <AccordionButton
                bg="landing.bg.primary.600"
                _hover={{
                  bg: 'landing.bg.primary.700'
                }}
                _focus={{
                  outlineColor: 'none'
                }}
                aria-label={item.title}
                fontSize={{
                  base: 'xl',
                  sm: 'xl'
                }}
                p={6}
                borderRadius="2xl"
                _expanded={{
                  borderBottomRadius: 0
                }}>
                <Box flex="1" textAlign="left">
                  {item.title}
                </Box>
                <AccordionIcon />
              </AccordionButton>

              <AccordionPanel
                bg="landing.bg.primary.500"
                borderBottomRadius="2xl"
                p={6}
                textStyle="landingBody"
                fontSize={{
                  base: 'lg',
                  sm: 'xl'
                }}>
                <VStack alignItems="stretch" gap={10}>
                  <Text>{item.content.text}</Text>

                  <VStack alignItems="stretch" gap={2}>
                    <Text>{item.content.list.title}</Text>
                    <UnorderedList>
                      {item.content.list.items.map((listItem) => (
                        <ListItem key={listItem} listStylePosition="outside">
                          {listItem}
                        </ListItem>
                      ))}
                    </UnorderedList>
                  </VStack>
                </VStack>
              </AccordionPanel>
            </AccordionItem>
          ))}
        </Accordion>
      </LandingSectionContainer>
      {/*<LandingSectionCurvedDivider curvedSide="top" bg="landing.bg.primary.500" />*/}
    </LandingSection>
  )
}
